export type ChatMessage = {
  from: 'them' | 'me'
  text: string
  time: string
}

export type WhatsAppChat = {
  name: string
  status: string
  avatar: string
  messages: ChatMessage[]
}

export const whatsappChats: WhatsAppChat[] = [
  {
    name: 'Martín',
    status: 'en línea',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/0655d861-5f09-4a62-80b6-831110358279.jpg',
    messages: [
      {
        from: 'them',
        text: 'hola! ya compré el Padel Pro-Pack y quería decirte que está buenísimo 🙌',
        time: '10:32',
      },
      { from: 'me', text: 'qué bueno Martín! me alegra que te esté sirviendo 💪', time: '10:34' },
      {
        from: 'them',
        text: 'sí, muy completo. me está ayudando a organizar todo el año de clases. los bonos son un golazo!',
        time: '10:36',
      },
      {
        from: 'them',
        text: 'ya lo recomendé a otros profes del club. gracias por el material 🔥',
        time: '10:40',
      },
    ],
  },
  {
    name: 'Carolina',
    status: 'en línea',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/645d01d6-8d45-4bf6-b2bd-32029e2e340b.jpg',
    messages: [
      {
        from: 'them',
        text: 'te cuento: usé el plan de iniciación del Tomo 7 con el grupo de las 9 y salió redondo',
        time: '18:05',
      },
      { from: 'me', text: 'buenísimo! y cómo reaccionaron las alumnas?', time: '18:07' },
      {
        from: 'them',
        text: 'me pidieron sumar una clase más por semana 😅 antes improvisaba todo el domingo a la noche',
        time: '18:11',
      },
      { from: 'me', text: 'eso es exactamente para lo que está hecho 🎾', time: '18:12' },
    ],
  },
  {
    name: 'Diego',
    status: 'últ. vez hoy a las 21:14',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/85e55bc8-a78b-41ab-ad6d-1af83b07df03.jpg',
    messages: [
      {
        from: 'them',
        text: 'con el tracker les mostré el progreso del mes y subí la hora de 15 a 20 sin que nadie se queje',
        time: '21:02',
      },
      { from: 'me', text: 'jaja te lo dije, la evidencia vende sola 😄', time: '21:05' },
      {
        from: 'them',
        text: 'tal cual. tres alumnos me pagaron el pack de 10 clases por adelantado esta semana',
        time: '21:09',
      },
      { from: 'them', text: 'lo mejor: recuperé mis domingos. gracias en serio 🙏', time: '21:14' },
    ],
  },
]
